// Тихие пустое/загрузочное состояния для списочных поверхностей (spec D
// «Warm Precision»): иконка 16px + одна строка 12px tertiary; скелетон —
// строки 42px с hairline-делителями на заливке surface-2. Без спиннеров и
// иллюстраций: список молчит, пока данных нет.
import type { ReactElement } from 'react';
import { Inbox } from 'lucide-react';

export interface QuietEmptyProps {
  /** Уже переведённая строка-подпись (одна строка, без заголовков). */
  text: string;
  testId?: string;
}

export function QuietEmpty({ text, testId }: QuietEmptyProps): ReactElement {
  return (
    <div
      {...(testId ? { 'data-testid': testId } : {})}
      className="flex items-center justify-center gap-2"
      style={{ padding: '18px 16px' }}
    >
      <Inbox size={16} style={{ color: 'var(--ant-color-text-tertiary)', flexShrink: 0 }} />
      <span className="truncate" style={{ fontSize: 12, color: 'var(--ant-color-text-tertiary)' }}>
        {text}
      </span>
    </div>
  );
}

export interface QuietListSkeletonProps {
  /** Число строк-скелетонов; по умолчанию — пять (первая страница списка). */
  rows?: number;
}

/** Скелетон таблицы: строки 42px, делители hairline, заливка D-поверхностей. */
export function QuietListSkeleton({ rows = 5 }: QuietListSkeletonProps): ReactElement {
  return (
    <div className="animate-pulse" style={{ display: 'flex', flexDirection: 'column' }}>
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={index}
          style={{
            height: 42,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '0 14px',
            borderBottom:
              index === rows - 1 ? 'none' : '1px solid var(--ant-color-border-secondary, #e7e5e4)',
          }}
        >
          <div
            style={{
              width: 22,
              height: 12,
              borderRadius: 3,
              background: 'var(--g-fill-strong, #e7e5e4)',
            }}
          />
          <div
            style={{
              width: '34%',
              height: 12,
              borderRadius: 3,
              background: 'var(--g-fill-strong, #e7e5e4)',
            }}
          />
          <div
            style={{
              width: '18%',
              height: 12,
              borderRadius: 3,
              background: 'var(--g-fill, #f5f1eb)',
            }}
          />
        </div>
      ))}
    </div>
  );
}
